//components
import { Section, Kicker, KickerDot, Grad } from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//theme
import { homeColor } from '@/theme/ai';

//styles
import {
  Columns,
  StepsHeader,
  StepsTitle,
  StepsList,
  StepRow,
  StepNumber,
  StepCopy,
  StepTitle,
  StepDescription,
  OutcomesCard,
  OutcomesHeader,
  OutcomesTitle,
  OutcomesList,
  OutcomeRow,
  OutcomeTitle,
  OutcomeDescription,
} from './HowItWorks.styles';

export function HowItWorks({
  stepsTitleWhite,
  stepsTitleGradient,
  steps,
  outcomes,
}) {
  return (
    <Section id="how-it-works">
      <Container>
        <Columns>
          <div>
            <StepsHeader>
              <Kicker>
                <KickerDot />
                What the agent does
              </Kicker>
              <StepsTitle>
                {stepsTitleWhite} <Grad>{stepsTitleGradient}</Grad>
              </StepsTitle>
            </StepsHeader>
            <StepsList>
              {steps.map((step, index) => (
                <StepRow key={step.title}>
                  <StepNumber>{String(index + 1).padStart(2, '0')}</StepNumber>
                  <StepCopy>
                    <StepTitle>{step.title}</StepTitle>
                    <StepDescription>{step.description}</StepDescription>
                  </StepCopy>
                </StepRow>
              ))}
            </StepsList>
          </div>
          <OutcomesCard>
            <OutcomesHeader>
              <Kicker color={homeColor.white}>
                <KickerDot />
                What changes
              </Kicker>
              <OutcomesTitle>
                What your team stops doing. And what that&rsquo;s worth.
              </OutcomesTitle>
            </OutcomesHeader>
            <OutcomesList>
              {outcomes.map((outcome) => (
                <OutcomeRow key={outcome.title}>
                  <OutcomeTitle>{outcome.title}</OutcomeTitle>
                  <OutcomeDescription>{outcome.description}</OutcomeDescription>
                </OutcomeRow>
              ))}
            </OutcomesList>
          </OutcomesCard>
        </Columns>
      </Container>
    </Section>
  );
}
